import React from 'react';
import { Link } from 'react-router-dom';
// import './../../scss/button.scss';

const Button = ({
  children,
  onClick,
  leftIcon: LeftIcon,
  rightIcon: RightIcon,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className = '',
  isLink = false,
  linkProps = {},
  ...props
}) => {

  if (isLink) {
    return (
      <Link
        to={linkProps.to}
        className={`btn ${variant} ${size} ${fullWidth ? 'full' : ''} ${className}`}
        {...linkProps}
      >
        {LeftIcon && <LeftIcon className="icon left" size={20} />}
        {children}
        {RightIcon && <RightIcon className="icon right" size={20} />}
      </Link>
    );
  }

  return (
    <button
      onClick={onClick}
      className={`btn ${variant} ${size} ${fullWidth ? 'full' : ''} ${className}`}
      {...props}
    >
      {LeftIcon && <LeftIcon className="icon left" size={20} />}
      {children}
      {RightIcon && <RightIcon className="icon right" size={20} />}
    </button>
  );
};

export default Button;
